import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BackToTopButton from "./BackToTopButton";
import WhatsAppFloatingButton from "./WhatsAppFloatingButton";
import LazyImage from "./LazyImage";

const resorts = {
  india: [
    { name: "Aanandakosha Ayurveda", id: "/india/aanandakosha" },
    { name: "Atmaneem Nature Cure", id: "/india/atmaneem" },
    { name: "Kairali Ayurveda", id: "/india/kairali" },
    { name: "Mekosha Ayurveda", id: "/india/mekosha-ayurveda" },
    { name: "Pema Wellness", id: "/india/pema-wellness" },
    { name: "The TravanCore Heritage", id: "/india/the-travan-core-heritage" },
    { name: "Veda5", id: "/india/veda-five" },
  ],
  vietnam: [
    { name: "Avana Retreat", id: "/vietnam/avana-retreat" },
    { name: "Bamboo Village", id: "/vietnam/bamboo-village" },
    { name: "Bliss Hoi An", id: "/vietnam/blisshoian" },
    { name: "Naman Retreat", id: "/vietnam/naman-retreat" },
  ],
  indonesia: [
    { name: "Fivelements Retreat, Bali", id: "/indonesia/five-elements-retreat-bali" },
    { name: "The Place Retreats, Bali", id: "/indonesia/the-place-retreat" },
    { name: "Soulshine, Bali", id: "/indonesia/souls-hine-bali" },
    { name: "Desa Seni", id: "/indonesia/desaseni" },
    { name: "SumberKima Hills", id: "/indonesia/sumber-kima-hill" },
  ],
  thailand: [
    { name: "Aleenta Resorts", id: "/thailand/aleenta-phuket" },
    { name: "Stay Wellbeing And Lifestyle Resort", id: "/thailand/stay-wellbeing-and-lifestyle-resort" },
  ],
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const submenuRef = useRef(null);

  const countries = Object.keys(resorts);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setIsSubmenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
    setIsSubmenuOpen(false);
  }, [location.pathname]);

  const handleResortClick = (resortId) => {
    navigate(resortId);
    setIsSubmenuOpen(false);
    setIsMobileOpen(false);
  };

  return (
    <div>
       <link
        href="https://fonts.googleapis.com/css2?family=Laila:wght@400;700&family=Playfair+Display:wght@400;700&display=swap"
        rel="stylesheet"
      />

      <div id="hero">
        <div className='headerContainer' >
          <div className='logoContainer-head' >
      <Link to="/" className="logo">
        {/* <img src="/images/images.png" alt="Logo" /> */}
        <LazyImage src="/images/imagess.jpg" alt="Logo" />
      </Link>
 </div>
      <nav className={`menuContainer ${isMobileOpen ? "open" : ""}`}>
        <ul className='menuList'>
          <li className='menuItem' ><Link to="/about-us">About Us</Link></li>
          <li className='menuItem' ><button className="submenu-toggle" onClick={() => setIsSubmenuOpen(prev => !prev)}>Wellness Centres</button></li>
          <li className='menuItem' ><Link to="/glossary">Wellness: Decoded</Link></li>
          <li className='menuItem' ><Link to="/blog">Wellness: Journal</Link></li>
          <li className='menuItem' ><Link to="/gallery">Wellness: Unfolded</Link></li>
          <li className='menuItem' ><Link to="/contact">Contact</Link></li>
        </ul>
         <div className='ctaWrapper'>
                <button className='ctaButton' onClick={() => navigate('/enquiry')}>
                  Book Now
                </button>
              </div>
      </nav>

      <button className="hamburger" onClick={() => setIsMobileOpen(prev => !prev)}>
        {isMobileOpen ? "✕" : "☰"}
      </button>

      {isSubmenuOpen && (
        <div className="submenuDropdown" ref={submenuRef}>
           <div className='countriesWrapper'>
          {countries.map((country) => (
            <div className="submenuSection" key={country}>
              <h4>{country.charAt(0).toUpperCase() + country.slice(1)}</h4>
              <ul>
                {resorts[country].map((resort) => (
                  <li key={resort.id}>
                    <button className="resortItem-head" onClick={() => handleResortClick(resort.id)}>
                      {resort.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
         </div>
      )}
 </div>
      </div>
      <WhatsAppFloatingButton />
      <BackToTopButton />

      <style>{`
       .resortItem-head {
          display: block;
          padding: 10px 15px;
          background-color: #f0f8ff;
          border-radius: 8px;
          color: #001F3F;
          text-decoration: none;
          font-size: 14px;
          transition: background 0.3s, color 0.3s;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
       .countriesWrapper {
          display: flex;
          justify-content: space-around;
          flex-wrap: nowrap;
          padding: 10px 0;
        }
        .hero {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: white;
          padding: 10px 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          position: fixed;
          width: 100%;
          top: 0;
          z-index: 1000;
        }
        .ctaWrapper {
          margin-top: 0px;
          display: flex;
          justify-content: center;
          margin-left: 20px;
        }

        .menuItem {
          position: relative;
          cursor: pointer;
          padding: 15px 0px;
          color: #001F3F;
          font-weight: bold;
          transition: background 0.3s, color 0.3s;
        }
        .menuItem .submenu-toggle {
            font-family: inherit;
        }
        .ctaButton {
          padding: 12px 28px;
          background-color: #f76c0d;
          color: #fff;
          border: none;
          border-radius: 30px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.3s ease;
          box-shadow: 0 4px 14px rgba(247, 108, 13, 0.3);
        }

        .ctaButtonHover {
          background-color: #d85e05;
          transform: translateY(-2px);
        }
        .menuList {
          list-style-type: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-grow: 1;
          justify-content: space-around;
          font-family: 'Laila', sans-serif;
          font-size: 0.9rem;
          color: #001F3F;
        }
        .headerContainer {
          display: flex;
          align-items: center;
          position: fixed;
          top: 0px;
          left: 0px;
          right: 0px;
          background-color: rgba(255, 255, 255, 0.9);
          border-bottom: 2px solid #e5e5e5;
          padding: 10px 20px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          z-index: 10;
        }
        .logo img {
          height: 50px;
        }
        .logoContainer-head {
          margin-right: 250px;
        }
        .menuContainer {
          display: flex;
          flex-grow: 1;
          justify-content: space-around;
        }

        .menuContainer ul {
          display: flex;
          list-style: none;
          gap: 16px;
          padding: 0;
          margin: 0;
        }
        .submenuSection ul {
          list-style: none;
          gap: 16px;
          padding: 0;
          margin: 0;
        }
        .submenuSection ul li{
          padding: 8px;
        }
        .submenuSection li a {
          cursor: pointer;
          text-decoration: none;
          border:none;
        }
        button.resortItem-head{
          border: none;
        }
        .menuItem a , .menuItem .submenu-toggle {
          color: #001F3F;
          text-decoration: none;
          font-size: 14px;
          background: none;
          border: none;
          font-weight: 600;
        }
        .menuContainer li button.submenu-toggle:hover,
        .menuContainer li a:hover {
          color: #f76c0d;
        }

        .cta {
          background: #f76c0d;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 30px;
          cursor: pointer;
        }

        .cta:hover {
          background: #d85e05;
        }

        .hamburger {
          display: none;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
        }

        .submenuDropdown {
          position: fixed; 
          top: 80px;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          max-width: 1200px;
          background-color: white;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
          border-radius: 10px;
          padding: 20px;
          z-index: 999;
          max-height: 500px;
          overflow-y: scroll;
        }

        .submenuSection {
          flex: 1;
        }

        .submenuSection h4 {
          color: #f76c0d;
          margin-bottom: 10px;
        }

        .submenuItem {
           flex: 0 0 auto;
          margin-right: 20px;
          text-align: center;
        }

        .submenuItem:hover {
          color: #f76c0d;
        }

        @media (max-width: 1350px) {
          .menuList{
            justify-content: end;
          }
          .logoContainer-head {
            margin-right: auto;
          }
          .menuItem a, .menuItem .submenu-toggle {
            padding: 0px;
          }
        }

        @media (max-width: 1100px) {
          .ctaWrapper {
            align-items: center;
          }
          .ctaButton {
            padding: 15px 22px;
            font-size: 15px;
          }
          .menuItem a, .menuItem .submenu-toggle {
            font-size: 13px;
          }
        }

        @media (max-width: 1050px) {
          .logo img {
              height: 38px;
          }
        }

        @media (max-width: 980px) {
          .menuContainer {
            position: absolute;
            top: 70px;
            left: 0;
            right: 0;
            flex-direction: column;
            background: #fff;
            padding: 20px;
            gap: 10px;
            transform: scaleY(0);
            transform-origin: top;
            transition: transform 0.3s;
            max-height: calc(100vh - 110px);
            overflow: auto;
          }
          .menuContainer ul {
                display: block;
                list-style: none;
                gap: 16px;
                padding: 0;
                margin: 0;
            }
              .countriesWrapper {
                  display: flow;
                  justify-content: space-around;
                  flex-wrap: nowrap;
                  padding: 10px 0;
              }
            .menuItem a, .menuItem .submenu-toggle {
                color: #001F3F;
                text-decoration: none;
                font-size: 14px;
                background: none;
                border: none;
                font-weight: 600;
                padding: 0px;
            }
            .menuItem {
              position: relative;
              cursor: pointer;
              padding: 9px 0px;
              color: #001F3F;
              font-weight: bold;
              transition: background 0.3s, color 0.3s;
          }
          .menuContainer.open {
            transform: scaleY(1);
          }

          .submenuSection ul {
            flex-direction: column;
          }

          .cta {
            width: 100%;
            margin-top: 10px;
          }

          .hamburger {
            display: block;
          }

          .submenuDropdown {
            flex-direction: column;
            padding: 10px;
          }

          .submenuItem {
            padding: 8px 10px;
          }
          .logo img {
            height: 50px;
          }
        }
      `}</style>
    </div>
  );
};

export default Header;
